import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

function Item({ to, icon, label, onClick }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => 'sidebar-item-cli' + (isActive ? ' active' : '')}
    >
      <i className={`bi ${icon}`} aria-hidden="true"></i>
      <span className="sidebar-label-cli">{label}</span>
    </NavLink>
  );
}

export default function Sidebar() {
  const { user, logout, temPermissao } = useAuth();
  const [drawerAberto, setDrawerAberto] = useState(false);
  const navigate = useNavigate();
  const isCliente = user?.tipo === 'cliente';

  const fechar = () => setDrawerAberto(false);

  const sair = () => {
    fechar();
    logout();
    navigate('/login', { replace: true });
  };

  const links = isCliente ? (
    <>
      <Item to="/home" icon="bi-house-door-fill" label="Início" onClick={fechar} />
      <Item to="/minhas-chaves-pix" icon="bi-qr-code" label="Minhas Chaves PIX" onClick={fechar} />
      <Item to="/meu-perfil" icon="bi-person-circle" label="Meu Perfil" onClick={fechar} />
    </>
  ) : (
    <>
      {temPermissao('notificacoes_enviar') && (
        <Item to="/notificacoes" icon="bi-megaphone-fill" label="Notificações" onClick={fechar} />
      )}
      {temPermissao('clientes_listar') && (
        <Item to="/clientes" icon="bi-people-fill" label="Clientes" onClick={fechar} />
      )}
      {temPermissao('usuarios_listar') && (
        <Item to="/usuarios" icon="bi-person-badge" label="Usuários" onClick={fechar} />
      )}
      <Item to="/perfis" icon="bi-shield-lock" label="Perfis" onClick={fechar} />
      <Item to="/meu-perfil" icon="bi-person-circle" label="Meu Perfil" onClick={fechar} />
    </>
  );

  return (
    <>
      <button
        type="button"
        className="sidebar-mobile-btn-cli"
        onClick={() => setDrawerAberto(true)}
        aria-label="Abrir menu"
      >
        <i className="bi bi-list"></i>
      </button>

      {drawerAberto && <div className="sidebar-backdrop-cli" onClick={fechar} />}

      <aside className={'sidebar-cli' + (drawerAberto ? ' open' : '')}>
        <div className="sidebar-brand-cli">
          <img src={logo} alt="Centrão" />
          <span className="sidebar-brand-text-cli">Centrão</span>
        </div>

        <nav className="sidebar-nav-cli">{links}</nav>

        <div className="sidebar-foot-cli">
          <div className="sidebar-user-cli">
            <i className="bi bi-person-fill" aria-hidden="true"></i>
            <span className="sidebar-label-cli">
              <strong>{user?.nome || '—'}</strong>
              <small>{user?.perfil_nome || (isCliente ? 'Cliente' : '')}</small>
            </span>
          </div>
          <button type="button" className="sidebar-item-cli sidebar-logout-cli" onClick={sair}>
            <i className="bi bi-box-arrow-right" aria-hidden="true"></i>
            <span className="sidebar-label-cli">Sair</span>
          </button>
        </div>
      </aside>
    </>
  );
}
